import React, {useEffect, useState} from 'react'
import Multiselect from 'multiselect-react-dropdown';
import {optionsSugar} from '../Options';
import Sidebar from '../Sidebar';
import { FarmGradeRates } from '../FarmGradeRates';
// import env from 'react-dotenv'
export const DateInput = ({x}) => {
  return (
    //dateHandler
      <div className="col-md-6">
          <label htmlFor="date" className="form-label">
              Date
          </label>
          <input
              id="num-value"
              type="date"
              className="form-control"
              required
              onChange={e => x(e.target.value)}
          />
      </div>
  );
};

export const Val=({x, title})=>{
  return(
    <>
      <div className="col-md-6">
          <label htmlFor="date" className="form-label">
              {title}
          </label>
          <input
              id="num-value"
              type="number"
              className="form-control"
              required
              onChange={e => x(e.target.value)}
          />
      </div>
    </>
  )
}


export const SugarPriceTypeInput = ({ x }) => {
  // Sugar price type input handler
  return (
    <div className="col-md-6">
      {/** Quality Type */}
      <label htmlFor="exampleFormControlTextarea1" className="form-label">
        Criteria
      </label>
      <div className="input-group mb-3">
        <select
          className="form-select"
          id="inputGroupSelect07"
          required
          onChange={(e) => x(e.target.value)}
          aria-label="Select example"
        >
          <option value="market-price-jodia-bazar">Market Price - Jodia Bazaar</option>
          <option value="market-price-akbari-mandi">Market Price - Akbari Mandi</option>
          <option value="mill-price">Mill Price</option>
          <option value="sugar-mill-gate">Sugar Mill Gate</option>
        </select>
      </div>
    </div>
  );
};


export const StationInput = ({x}) =>{
  const [selectedOptions, setSelectedOptions] = useState([])
  const [options, setOptions] = useState([])

  const handleSelectStateOptions =  (selectedList)=>{
    setSelectedOptions(selectedList)
  }
  useEffect(()=>{
    x(selectedOptions)
  },[selectedOptions])

  const ferrit = async() =>{
    const response = await fetch(`${process.env.REACT_APP_API_URL}/getLookup`)
    const data = await response.json()
    setOptions(data)
  }

  useEffect(()=>{
    ferrit()
  },[])
  //stationHandler
  return(
    <div className="col-md-6">
    <label for="formGroupExampleInput2" class="form-label">Station</label>
            <Multiselect 
              singleSelect={true}
              options={options}
              displayValue='name' 
              selectedValues={selectedOptions}
              onSelect={handleSelectStateOptions}
              onRemove={(selectedList) => {
                setSelectedOptions(selectedList);
            }}
              closeOnSelect={false}
              avoidHighlightFirstOption
            />
    </div>
  )
}

export const ByProduct=({x, options, title}) =>{
  const [selectedOptions, setSelectedOptions] = useState([])

  const handleSelectStateOptions =  (selectedList)=>{
    setSelectedOptions(selectedList)
  }
  useEffect(()=>{
    x(selectedOptions)
  },[selectedOptions])
  //stationHandler
  return(
    <div className="col-md-6">
    <label for="formGroupExampleInput2" class="form-label">{title}</label>
            <Multiselect 
              selectionLimit={1}
              options={options}
              displayValue='name' 
              selectedValues={selectedOptions}
              onSelect={handleSelectStateOptions}
              onRemove={(selectedList) => {
                setSelectedOptions(selectedList);
            }}
              closeOnSelect={false}
              avoidHighlightFirstOption
            />
    </div>
  )
}


export default function SugarInput() {
    const [MJB, setMJB] = useState(true)
    const [MAM, setMAM] = useState(false)
    const [MP, setMP] = useState(false)
    const [FMG, setFMG] = useState(false)

    //Sugar common values
    const [date, setDate] = useState("")
    const [prodDetails, setProdDetails] = useState({})
    const [location, setLocation] = useState({});
    const [sugarType, setSugarType] = useState('')

    const [mP, setmP] = useState({
      sugar_mills_id:"",
      mill_rates:""
    });

    const [mJB, setmJB] = useState({
      market_name:"",
      future_d_o:"",
      d_o_price:"",
      wholesale:"",
      delivered:"",
      retail_price:""
    });

    const [mAM, setmAM] = useState({
      market_name:"",
      south_punjab:"",
      central_punjab:"",
      wholesale:"",
      retail_price:""
    })
    
    
    //Setter for the type of the field
    const switcher = (a, b, c, d)=>{
        setMJB(a)
        setMAM(b)
        setMP(c)
        setFMG(d)
    }

    //Updating the state of the field
    useEffect(()=>{
      console.log(sugarType)
      sugarType == "market-price-jodia-bazar" ? switcher(true, false, false, false) : sugarType == "market-price-akbari-mandi" ? switcher(false, true, false, false) : sugarType == "mill-price" ? switcher(false, false, true, false) : sugarType == "sugar-mill-gate" ? switcher(false, false, false, true) : console.log("");
    },[sugarType])


    useEffect(()=>{
      const car = location[0]
      if (Array.isArray(location) && location.length > 0) {
        // Access the name property of the first element in the location array
        const nameOfFirstElement = location[0].name;
        console.log(nameOfFirstElement); // Output: "Karen"
    } else {
        console.error("Location array is empty or undefined.");
    }
    }, [location])


    useEffect(()=>{
      console.log(mP)
    },[mP])

    const handleSubmit =(e)=>{
      e.preventDefault();
      const input = {
      date: date,
      by_product : prodDetails[0].name,
      by_product_id:prodDetails[0].value,
      product :prodDetails[0].product,
      station: location[0].name,
       station_id: location[0].value,
      district :location[0].district,
      district_id :location[0].district_id,
      province:location[0].province,
      province_id: location[0].province,
      sugar_price_type: sugarType,
      }
      if(sugarType === "mill-price"){
        input.sugar_mills_id = mP.sugar_mills_id
        input.mill_rates = mP.mill_rates
        fetch(`${process.env.REACT_APP_API_URL}/crop-price/sugar-mills-single`, {
        
          method: 'POST',
          headers: {
            "Content-Type" : "application/json"
          },
          body: JSON.stringify(input)
        }).then(() => {
          console.log("New price record(s) added");    
         
        }).catch((err) => {
          console.log("Unable to add record" + err);
        });
      }
      else if(sugarType==="market-price-akbari-mandi"){
        input.market_name = mAM.market_name
        input.central_punjab = mAM.central_punjab
        input.south_punjab= mAM.south_punjab
        input.wholesale = mAM.wholesale
        input.retail_price = mAM.retail_price
        fetch(`${process.env.REACT_APP_API_URL}/crop-price/akbari-mandi-single`, {
        
          method: 'POST',
          headers: {
            "Content-Type" : "application/json"
          },
          body: JSON.stringify(input)
        }).then(() => {
          console.log("New price record(s) added");    
         
        }).catch((err) => {
          console.log("Unable to add record" + err);
        });
      }
      else if(sugarType === "market-price-jodia-bazar"){
        input.market_name= mJB.market_name
        input.future_d_o = mJB.future_d_o
        input.d_o_price = mJB.d_o_price
        input.wholesale = mJB.wholesale
        input.delivered = mJB.delivered
        input.retail_price = mJB.retail_price
        fetch(`${process.env.REACT_APP_API_URL}/crop-price/jodia-bazaar-single`, {
        
          method: 'POST',
          headers: {
            "Content-Type" : "application/json"
          },
          body: JSON.stringify(input)
        }).then(() => {
          console.log("New price record(s) added");    
         
        }).catch((err) => {
          console.log("Unable to add record" + err);
        });
      }
    }

  return (
    <>
     <div className="sidebar">
      <Sidebar/>
      </div>
    <div id='tabler'>
    <h1>Sugar Form</h1>
      <div className="row">
        <SugarPriceTypeInput x={setSugarType}></SugarPriceTypeInput>
        <DateInput x={setDate}></DateInput>
        <StationInput x={setLocation}></StationInput>
        <ByProduct x={setProdDetails} options={optionsSugar} title={"Byproduct"} ></ByProduct>

        {MJB && <div className="row">
          <div className='col-md-6' >
          <div className="mb-3" >
            <label for="number" className="form-label">
              Market Name
            </label>
            <input id="num-value"type="text" className="form-control" min="0" onChange={(e) => {setmJB({...mJB, market_name:e.target.value})}} />
          </div>
        </div>

            <div className='col-md-6' >
        <div className="mb-3" >
          <label for="number" className="form-label">
            Future DO
          </label>
          <input id="num-value"type="number" className="form-control" min="0" onChange={(e) => {setmJB({...mJB, future_d_o:e.target.value})}}  />
        </div>
        </div>

      <div className='col-md-6' >
              <div className="mb-3">
                <label for="number" className="form-label">
                  DO Price
                </label>
                <input id="num-value"type="number" className="form-control" min="0" onChange={(e) => {setmJB({...mJB, d_o_price:e.target.value})}} />
              </div>
            </div>


            <div className='col-md-6' >
              <div className="mb-3">
                <label for="number" className="form-label">
                  Wholesale
                </label>
                <input id="num-value"type="number" className="form-control" min="0" onChange={(e) => {setmJB({...mJB, wholesale:e.target.value})}} />
              </div>
            </div>


            <div className='col-md-6' >
              <div className="mb-3">
                <label for="number" className="form-label">
                  Delivered
                </label>
                <input id="num-value"type="number" className="form-control" min="0" onChange={(e) => {setmJB({...mJB, delivered:e.target.value})}} />
              </div>
            </div>


            <div className='col-md-6' >
              <div className="mb-3">
                <label for="number" className="form-label">
                  Retail Price
                </label>
                <input id="num-value"type="number" className="form-control" min="0" onChange={(e) => {setmJB({...mJB, retail_price:e.target.value})}} />
              </div>
            </div>
        
        </div>}

        {MAM &&
        <div className='row'>
          
          <div className='col-md-6' >
          <div className="mb-3" >
            <label for="number" className="form-label">
              Market Name
            </label>
            <input id="num-value"type="text" className="form-control" min="0" onChange={(e) => {setmAM({...mAM, market_name:e.target.value})}} />
          </div>
        </div>

            <div className='col-md-6' >
        <div className="mb-3" >
          <label for="number" className="form-label">
            Central Punjab
          </label>
          <input id="num-value"type="number" className="form-control" min="0" onChange={(e) => {setmAM({...mAM, central_punjab:e.target.value})}}/>
        </div>
        </div>

      <div className='col-md-6' >
              <div className="mb-3">
                <label for="number" className="form-label">
                  South Punjab
                </label>
                <input id="num-value"type="number" className="form-control" min="0" onChange={(e) => {setmAM({...mAM, south_punjab:e.target.value})}}/>
              </div>
            </div>


            <div className='col-md-6' >
              <div className="mb-3">
                <label for="number" className="form-label">
                  Wholesale
                </label>
                <input id="num-value"type="number" className="form-control" min="0" onChange={(e) => {setmAM({...mAM, wholesale:e.target.value})}}/>
              </div>
            </div>

            <div className='col-md-6' >
              <div className="mb-3">
                <label for="number" className="form-label">
                  Retail Price
                </label>
                <input id="num-value"type="number" className="form-control" min="0" onChange={(e) => {setmAM({...mAM, retail_price:e.target.value})}}/>
              </div>
            </div>
            </div>}


{MP &&
  <div className='row'>
    <div className='col-md-6' >
          <div className="mb-3" >
            <label for="number" className="form-label">
              Sugar Mills ID
            </label>
            <input id="num-value"type="text" className="form-control" min="0"onChange={(e) => {setmP({...mP, sugar_mills_id:e.target.value})}} />
          </div>
        </div>

        <div className='col-md-6' >
          <div className="mb-3" >
            <label for="number" className="form-label">
              Mill Rates
            </label>
            <input id="num-value"type="text" className="form-control" min="0" onChange={(e) => {setmP({...mP, mill_rates:e.target.value})}} />
          </div>
        </div>
    </div>
}

        
          </div>
          <button type="button" class="btn submit-btn" onClick={handleSubmit}>Submit</button>
    </div>
    </>
   
  )
}
